import React from "react";
import "../scss/confirmationModal.scss"

const ConfirmationModal = ({ message, onConfirm, onCancel }) => {
  return (
    <div id="modal-overlay" className="d-flex flex-column align-items-center justify-content-center p-4">
      <div className="bg-white shadow rounded p-4 text-center confirmation-text">
        
        <div className="mb-3">
          <p className="fw-normal">{message}</p>
        </div>

        <div className="d-flex justify-content-center gap-3">
          <div
            onClick={onConfirm}
            className="btn btn-success pointer"
          >
            Proceed
          </div>
          <div
            onClick={onCancel}
            className="btn btn-outline-success"
          >
            Cancel
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;